<script>
import CartPanel from '@phoenix/mixins/components/checkout/summary/CartPanel';
import { mapActions, mapGetters, mapState } from 'vuex';
import laravelRoute from 'ziggyRoute';
import Panel from '@maison/components/common/Panel.vue';
import CartContent from '@maison/components/checkout/summary/CartContent.vue';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: {
    PhxsgButton,
    CartContent,
    Panel,
  },

  mixins: [CartPanel],

  data() {
    return {
      checkoutUrl: laravelRoute('checkout_page'),
    };
  },

  computed: {
    ...mapState('cartPreview', ['loading', 'cart']),

    ...mapGetters('cartPreview', ['hasItems', 'cartTotal', 'cartItems']),
  },

  methods: {
    ...mapActions('wishlist', ['refreshWishlistFromLocalStorage']),
  },
};
</script>

<template>
  <panel
    id="cart-panel"
    open-from="end"
    :options="{ ...panelOptions, closeAll: true }"
    :title="$t('Checkout.cartTitle')"
    :classes="['cart-panel']"
  >
    <template #content>
      <div v-if="loading" class="center center--and-text">
        <div class="loader loader--dark">
          <div class="loader__inner"></div>
        </div>
      </div>

      <cart-content v-if="hasItems" :cart-items="cartItems" data-cy="cart-summary-content" />
    </template>

    <template #footer>
      <template v-if="hasItems">
        <div class="stack stack--spacing-4">
          <div class="cluster cluster--justify-between heading-small">
            <span>{{ $t('Checkout.totalPrice') }}</span>
            <span>{{ cartTotal }}</span>
          </div>

          <a :href="checkoutUrl" class="btn btn--primary btn--plain" data-cy="proceed-to-checkout-btn">
            <span class="btn__text">{{ $t('Checkout.proceedToCheckout') }}</span>
          </a>
        </div>
      </template>

      <template v-else>
        <div class="stack stack--spacing-4">
          <div class="cluster cluster--justify-between heading-small">
            <span>{{ $t('Checkout.emptyShoppingBagTitle') }}</span>
          </div>

          <PhxsgButton variant="plain" color="primary" data-panel-close="cart-panel">
            {{ $t('Checkout.continueShopping') }}
          </PhxsgButton>
        </div>
      </template>
    </template>
  </panel>
</template>
